// TODO: confirm with client
export const b2bFirstOrderDiscountRate = 0.05;
